import { render, staticRenderFns } from "./metas.vue?vue&type=template&id=ae2f1888"
import script from "./metas.vue?vue&type=script&lang=js"
export * from "./metas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports